export default "__VITE_ASSET__DA4bgfgP__"